import React from 'react';
import axios from 'axios';
import Request from '@/utils/request';
import { Statistic, Row, Col, Button, Card, Progress } from 'antd';
import moment from 'moment';
import { getKeyFromDate } from '@/utils/tools';
import { sortedIndexBy } from 'lodash-es';

import './Home.scss';

interface IProps {
  userStore: any
}
interface IState {}

class Home extends React.PureComponent<IProps, IState> {
  state = {
    gridRank: [],
    newBondRank: [],

    gridRankLoading: true,
    newBondRankLoading: true,
  }

  componentDidMount() {
    axios.get(`/gridDaily/top?num=10`).then((res) => {
      // let allData = [];
      // let dateMap = {};

      // res.data.forEach((item) => {
      //   const key = moment(item.date).format('YYYY-MM-DD');

      //   if (dateMap[key] === undefined) {
      //     allData.push({
      //       date: key,
      //       profit: 0
      //     })

      //     dateMap[key] = allData.length - 1;
      //   }

      //   allData[dateMap[key]].profit += Number(item.profit);
      //   allData[dateMap[key]]._id = item._id;
      // });

      // allData.sort((v1, v2) => {
      //   return v2.profit - v1.profit;
      // });
      this.setState({
        gridRank: res.data,
        gridRankLoading: false,
      });
    });

    axios.get(`/rank/newBond`).then((res) => {
      this.setState({
        newBondRank: res.data,
        newBondRankLoading: false,
      });
    });
  }

  render() {
    return (
      <React.Fragment>
      <Row gutter={ 16 }>
        <Col md={ 8 } xs={ 24 }>
          <Card title="网格收益排行榜" loading={ this.state.gridRankLoading }>
            {
              this.state.gridRank.map((item) => {
                return (
                  <p className='home-list-row' key={ item._id }>
                    <span>{ item.date.substring(0, 10) }</span>
                    <span>{ item.profit }</span>
                  </p>
                )
              })
            }
          </Card>
        </Col>
        <Col md={ 8 } xs={ 24 }>
          <Card title="新债收益率排行榜" loading={ this.state.newBondRankLoading }>
            {
              this.state.newBondRank.map((item) => {
                return (
                  <p className='home-list-row' key={ item._id }>
                    <span>{ item.date.substring(0, 10) }</span>
                    <span>{ item.newName }</span>
                    <span>{ (item.yield * 100).toFixed(2) }%</span>
                  </p>
                )
              })
            }
          </Card>
        </Col>
      </Row>
      </React.Fragment>
    )
  }
}

export default Home;
